var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAnalysisandInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.17,
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#DC2418"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7009 43.7445L47.8954 35.939C50.3583 32.7625 50.1393 28.1639 47.2235 25.2486C44.0631 22.0882 38.9205 22.0882 35.7601 25.2486C32.5997 28.4094 32.5997 33.5516 35.7601 36.7124C38.6755 39.6277 43.2736 39.8467 46.4506 37.3843L54.2561 45.1894C54.6558 45.5887 55.302 45.5887 55.7009 45.1898C56.0998 44.7905 56.0998 44.1442 55.7009 43.7445ZM45.7783 35.2671C43.4149 37.6309 39.5688 37.6313 37.205 35.2671C34.8412 32.9037 34.8412 29.0576 37.205 26.6938C39.5684 24.3304 43.4145 24.3297 45.7783 26.6938C48.142 29.0572 48.142 32.9033 45.7783 35.2671Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9728 42.0689V20.8939H53.0882V39.8664L55.061 41.8392V20.6966C55.061 19.7181 54.264 18.9211 53.2855 18.9211H17.7755C16.7966 18.9211 16 19.7181 16 20.6966V42.2661C16 43.2446 16.7966 44.0416 17.7755 44.0416H31.9842V49.6656C31.9842 50.3446 32.5358 50.8962 33.214 50.8962H37.0574C37.7356 50.8962 38.2868 50.3446 38.2868 49.6656V44.0416H52.1413L50.1685 42.0689H17.9728ZM33.214 49.6656V44.0416H37.0574L37.0582 49.6664L33.214 49.6656Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4449 48.3841V49.5678C41.3608 49.5678 41.2922 49.4991 41.2922 49.4151V51.8956H28.9793V49.4151C28.9793 49.4991 28.9106 49.5678 28.8266 49.5678V48.3841C28.258 48.3841 27.7956 48.8465 27.7956 49.4151V52.0483C27.7956 52.6169 28.258 53.0793 28.8266 53.0793H41.4449C42.0134 53.0793 42.4758 52.6169 42.4758 52.0483V49.4151C42.4762 48.8465 42.0138 48.3841 41.4449 48.3841Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1032 39.9888H34.1239C34.247 39.9888 34.3464 39.8893 34.3464 39.7666V36.0582C33.7238 35.1637 33.2862 34.1825 33.0298 33.1618L30.8803 35.3989V39.767C30.8803 39.8893 30.9801 39.9888 31.1032 39.9888Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5206 39.9888C39.6437 39.9888 39.7435 39.8893 39.7435 39.7666V39.6625C38.4849 39.3914 37.308 38.8481 36.2774 38.0653V39.7666C36.2774 39.8897 36.3772 39.9888 36.4999 39.9888H39.5206Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5206 34.8398H38.0564C38.5536 35.3022 39.1245 35.6589 39.7435 35.8972V35.0631C39.7439 34.9396 39.6441 34.8398 39.5206 34.8398Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6214 39.9888C44.7445 39.9888 44.844 39.8893 44.844 39.7666V39.2659C43.8252 39.6589 42.7335 39.8672 41.6315 39.8672C41.5526 39.8672 41.4752 39.8586 41.3975 39.8562C41.4322 39.9339 41.5092 39.9888 41.6003 39.9888H44.6214Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.432 30.2365C44.2426 30.2365 44.0576 30.1695 43.9124 30.0479L43.3632 29.5891L41.3778 31.7548V36.2381C41.4654 36.2425 41.5518 36.2503 41.6406 36.2503C42.8163 36.2503 43.9294 35.8645 44.844 35.1622V30.1217C44.8317 30.1292 44.8203 30.1375 44.8077 30.1446C44.6924 30.2046 44.5622 30.2365 44.432 30.2365Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7646 33.6822L43.3458 28.6844L44.4178 29.5804C44.4703 29.6238 44.5437 29.6321 44.6045 29.6005C44.6644 29.5689 44.6999 29.5042 44.6948 29.436L44.462 26.8378C44.4537 26.7451 44.3717 26.6765 44.2793 26.6848L41.6812 26.9171C41.6133 26.9235 41.5561 26.9696 41.5352 27.0347C41.5285 27.0564 41.5269 27.0781 41.5281 27.1002C41.5321 27.1436 41.5526 27.1854 41.5881 27.2142L42.6617 28.1119L38.3097 32.8595L36.5169 32.1998C36.6064 32.5786 36.7366 32.9448 36.9059 33.2928L38.2821 33.799C38.4526 33.8613 38.6431 33.8155 38.7646 33.6822Z",
    fill: "#DC2418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7631 31.2482L29.8213 34.3099C29.6504 34.4875 29.6563 34.7696 29.8339 34.94C29.9203 35.0233 30.0316 35.0643 30.1424 35.0643C30.2596 35.0643 30.3764 35.0185 30.4636 34.9274L32.8751 32.418C32.812 32.0302 32.7749 31.6396 32.7631 31.2482Z",
    fill: "#DC2418"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalysisandInsights);
export default __webpack_public_path__ + "static/media/dataAnalysisandInsights.985b4af12aec2ec409a2f8900ebb412b.svg";
export { ForwardRef as ReactComponent };